import * as types from '../const/action.types';

export function catalogHasErrored(state = { hasErrored: false, error: '' }, action) {
    switch (action.type) {
        case types.CATALOG_HAS_ERROR:
            return {
                hasErrored: action.hasErrored,
                error: action.error,
            };

        default:
            return state;
    }
}

export function catalogIsLoading(state = false, action) {
    switch (action.type) {
        case types.CATALOG_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}

export function catalogIsSaving(state = false, action) {
    switch (action.type) {
        case types.CATALOG_IS_SAVING:
            return action.isSaving;
        default:
            return state;
    }
}

export function catalog(state = {}, action) {
    switch (action.type) {
        case types.CATALOG_FETCH_DATA:
            return action.items;
        default:
            return state;
    }
}

export function catalogs(state = [], action) {
    switch (action.type) {
        case types.CATALOGS_FETCH_DATA_SUCCESS:
            return action.items;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/api.catalog.reducer.js